import { render, staticRenderFns } from "./PendingWallpapers.vue?vue&type=template&id=68e12488&scoped=true"
import script from "./PendingWallpapers.vue?vue&type=script&lang=js"
export * from "./PendingWallpapers.vue?vue&type=script&lang=js"
import style0 from "./PendingWallpapers.vue?vue&type=style&index=0&id=68e12488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e12488",
  null
  
)

export default component.exports